
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CitationAuthorFormItem } from '@/types/CitationAuthor';
import {
  IndividualCitationAuthor,
  OrganisationCitationAuthor
} from '@/jbi-shared/types/citation.fields';

@Component({})
export default class CitationAuthors extends Vue {
  @Prop() public author!: CitationAuthorFormItem;
  @Prop() public isOnlyAuthorInList!: boolean;

  get isIndividual() {
    return this.author.type === 'Individual';
  }

  get literal(): string {
    return (this.author as OrganisationCitationAuthor).literal;
  }
  set literal(value: string) {
    (this.author as OrganisationCitationAuthor).literal = value;
  }

  get given() {
    return (this.author as IndividualCitationAuthor).given;
  }
  set given(value: string) {
    (this.author as IndividualCitationAuthor).given = value;
  }

  get family() {
    return (this.author as IndividualCitationAuthor).family;
  }
  set family(value: string) {
    (this.author as IndividualCitationAuthor).family = value;
  }

  handleInputChange(event: Event) {
    const input = event.target as HTMLInputElement | HTMLSelectElement;
    const field = input.name as keyof CitationAuthorFormItem;
    const value =
      typeof input.value === 'string' ? input.value.trim() : input.value;

    // As form values are strings, the dev still needs to
    // ensure the type is correct when creating the new object
    const newAuthor: CitationAuthorFormItem = {
      ...this.author,
      [field]: value
    };

    // clear properties of the "other" type as the user changes
    // the author type from the dropdown
    ({
      ['Organisation']: () => {
        const author = newAuthor as IndividualCitationAuthor;

        author.given = '';
        author.family = '';
      },
      ['Individual']: () => {
        const author = newAuthor as OrganisationCitationAuthor;

        author.literal = '';
      }
    }[newAuthor.type]());

    this.$emit('update', newAuthor);
  }

  removeAuthor() {
    this.$emit('remove', this.author.id);
  }
}
